export const QA_NAME_DOC_FLOW_EPOST_VALIDATION_PREVIEW_DOWNLOAD_BUTTON =
  'docFlowEpostValidationPreviewDownloadButton'
